import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { articles } from "@/mocks/articles";

export default function LatestFeed() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="LATEST"
        title="最新爆料 · 持续更新中"
        desc="编辑组每日整理公开报道与热点线索，标注时间与来源，方便你自行判断。"
      />
      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {articles.slice(0, 6).map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>
    </section>
  );
}